<template>
  <div class="signup-login-wrapper">
    <div class="logo-wrapper">
      <a href="/">
        <GkLogoAnim theme="white" />
      </a>
    </div>
    <div class="signup-login-form-wrap">
      <transition name="fade" appear mode="out-in">
        <SignupFormAccountants
          :key="mainTransitionKey"
          @authorised="$emit('authorised', false)"
          :remember-email="rememberEmail"
          @remember-email="(email) => { rememberEmail = email }"
        />
      </transition>
    </div>
    <transition name="fade-delayed" appear mode="out-in">
      <div class="security">
        <div class="secure-online">
          <font-awesome-icon icon="fa-solid fa-shield-check" />
          <div>{{ $gettext('All your data is securely transmitted from you, and securely stored on, our European servers.') }}</div>
        </div>
        <div class="signup-link-wrap">
          {{ $gettext('Already have an account?') }} <router-link data-analytics-click="signup from login" :to="{ name: 'Login' }" class="signup-link text-blue">{{ $gettext('Sign in') }}</router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import GkLogoAnim from "@/components/ui/GkLogoAnim"
import GekkoButton from "@/components/GekkoButton"

import SignupFormAccountants from '@/components/signup/SignupFormAccountants'

export default {
  name: 'SignupAccountants',
  components: {
    GekkoButton,
    GkLogoAnim,
    SignupFormAccountants,
  },
  data () {
    return {
      mainTransitionKey: 0,
      rememberEmail: ''
    }
  },
  computed: {
    ...mapGetters({ 
      isAuthenticated: "auth/getAuthenticated",
      isNewAccount: "signup/getSignupStatus",
    })
  },
  created () {
    this.setupData()
  },
  mounted () {
    
  },
  methods: {
    setupData () {
      if (this.isAuthenticated) {
        console.log('Signup.vue::setupData() -> User is already logged in, redirecting to Dashboard')
        if (this.isNewAccount) {
          this.$router.push({ name: 'Dashboard', query: { welcome: 'yes' }  }).catch(() => {})
        } else {
          this.$router.push({ name: 'Dashboard' }).catch(() => {})
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>
  .signup-login-wrapper {
    max-width: 540px;
    width: 540px;
  }
</style>